var globalCount = 0;

var urlStringify = function (url, data) {
    if (!data) {
        return url;
    }
    var param = [];
    for (var o in data) {
        if (data.hasOwnProperty(o)) {
            param.push(o + '=' + data[o]);
        }
    }
    return ~url.indexOf('?') ? url + param.join('&') : url + '?' + param.join('&');
};

/**
 * jsonp
 * */
module.exports = function (options) {

    if (!options.url) {
        throw new Error('url request!');
    }
    var data = options.data || {};
    var cb = options.onSuc || function () {
    };
    var cbName = data.callback = 'KNB' + (++globalCount) + (+new Date());

    var script = document.createElement('script');
    script.src = urlStringify(options.url, data);

    window[cbName] = function (res) {
        delete window[cbName];
        script.parentNode.removeChild(script);
        cb(res);
    };

    document.getElementsByTagName('head')[0].appendChild(script);
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/common/request.js
// module id = 512
// module chunks = 0